<div [ngClass]="{ main_container_comparableChart: comparableChart }">
  <div class="ai_analysis-custom-barchart-header" *ngIf="comparableChart">
    <div>
      <div
        class="custom-barchart-header-icon"
        [ngStyle]="{ backgroundImage: 'url(' + your_icon_src + ')' }"
      >
        <!-- <img [src]="your_icon_src" alt="" /> -->
      </div>
    </div>
    <div>
      <svg
        (click)="sortFunctionShapleyValue('client')"
        class="custom_table_sort-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        [ngClass]="{
          active: prevSortType === 'client' && !sortToogle
        }"
      >
        <g clip-path="url(#clip0_1676_4762)">
          <path
            d="M12 8V15"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16 12L12 8"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 12L12 8"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1676_4762">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      VS
      <svg
        (click)="sortFunctionShapleyValue('competitor')"
        class="custom_table_sort-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        [ngClass]="{
          active: prevSortType === 'competitor' && !sortToogle
        }"
      >
        <g clip-path="url(#clip0_1676_4762)">
          <path
            d="M12 8V15"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16 12L12 8"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 12L12 8"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1676_4762">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div>
      <div
        class="custom-barchart-header-icon"
        [ngStyle]="{ backgroundImage: 'url(' + competitor_icon_src + ')' }"
      >
        <!-- <img [src]="competitor_icon_src" alt="" /> -->
      </div>
    </div>
  </div>
  <div
    class="ai_analysis-custom-barchart_container"
    [ngClass]="{ comparableChart: comparableChart }"
  >
    <!-- single chart -->
    <ng-container *ngIf="!comparableChart && !loadingChart">
      <ng-container *ngIf="!barchartData || barchartData?.length === 0">
        <!-- <div class="ai_analysis-custom-barchart">
          <div class="ai_analysis-custom-barchart_text-container">
      
            <p class="custom-barchart_text_name">
              No data available at the moment!
            </p>
          </div>
          <div class="ai_analysis-custom-barchart_bars-container">
            <div class="ai_analysis-custom-barchart_bars"></div>
          </div>
        </div> -->
      </ng-container>
      <div
        class="ai_analysis-custom-barchart_with_description"
        *ngIf="barchartData && barchartData?.length > 0"
      >
        <div class="ai_analysis_gr_container" *ngIf="!showV2Design">
          <div class="ai_analysis_gr_main">
            <div class="ai_analysis_gr_main-header">
              <div class="ai_analysis_gr_main-header-title">
                <h2>{{ "words." + cardName | translate }}</h2>
              </div>
            </div>
            <div class="ai_analysis-custom-barchart-dataholder">
              <div class="ai_analysis_gr_table">
                <div class="ai_analysis_gr_table_header">
                  <div class="ai_analysis_gr_table_grp1">
                    <h3>{{ "words.factor" | translate }}</h3>
                  </div>
                  <div class="ai_analysis_gr_table_grp2">
                    <h3>{{ "words.keywords" | translate }}</h3>
                  </div>
                  <div class="ai_analysis_gr_table_grp3">
                    <h3>
                      {{ "words.ranking_impact" | translate }}
                      <svg
                        (click)="sortFunction()"
                        class="custom_table_sort-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        [ngClass]="{
                          active: rankingImpactDirection !== '1'
                        }"
                        style="position: absolute; margin-top: -4px"
                      >
                        <g clip-path="url(#clip0_1676_4762)">
                          <path
                            d="M12 8V15"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M16 12L12 8"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M8 12L12 8"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1676_4762">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </h3>
                  </div>
                </div>
                <div class="ai_analysis_gr_table_content_scroll">
                  <ng-container *ngIf="isFreemiumUser">
                    <ng-container
                      *ngFor="let chartData of barchartData; let i = index"
                    >
                      <div
                        *ngIf="i < 3"
                        class="ai_analysis_gr_table_content"
                        (click)="onChartClick(chartData)"
                        [ngClass]="{
                          selected: chartData.selected,
                        }"
                      >
                        <div class="ai_analysis_gr_table_grp1">
                          <h1>
                            {{
                              chartData?.value >= 0 ?  rename_variables_positive?.[removeCommas(chartData?.name)]?.name ??
                              chartData.name : 
                                renamed_variables?.[removeCommas(chartData?.name)]?.name ??
                              chartData.name

                            }}
                          </h1>
                        </div>
                        <div
                          class="ai_analysis_gr_table_grp2"
                          style="padding-left: 5px; box-sizing: border-box"
                        >
                          <span
                            >{{
                          formatNumberWithCommas(
                            barchartInputData?.variable_labels?.[chartData.name]
                          )
                            }}
                          </span>
                        </div>
                        <div
                          class="ai_analysis_gr_table_grp3"
                          style="padding-left: 5px; box-sizing: border-box"
                        >
                          <div
                            class="percentage"
                            [ngClass]="{
                              positive: chartData?.value > 0,
                              negative: chartData?.value < 0,
                              neutral: chartData?.value == 0
                            }"
                          >
                            {{ formatValue(chartData.value) }}
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <div class="ai_analysis_gr_table_content-blurLayer">
                      <div
                        class="ai_analysis_gr_table_content-blurLayer-content"
                      >
                        <h4>{{ "phrases.View_all_SEO_issues" | translate }}</h4>
                        <p>
                          {{
                            "phrases.View_all_issues_impacting_your_site_and_improve_them_to_achieve_higher_ranking"
                              | translate
                          }}
                        </p>
                        <button
                          style="background-color: #635bff !important"
                          class="primary"
                          mat-raised-button
                          type="button"
                          (click)="redirectToBilling()"
                        >
                          <span style="color: #fff">
                            {{ "words.view_more" | translate }}
                          </span>
                        </button>
                      </div>
                      <div
                        class="ai_analysis_gr_table_content-blurLayer-blurred"
                      >
                        <div
                          class="ai_analysis_gr_table_content"
                          *ngFor="let i of [].constructor(3)"
                        >
                          <div class="ai_analysis_gr_table_grp1">
                            <span class="blurred-element"></span>
                          </div>
                          <div
                            class="ai_analysis_gr_table_grp2"
                            style="
                              padding-left: 5px;
                              box-sizing: border-box;
                              width: 19%;
                            "
                          >
                            <span class="blurred-element"></span>
                          </div>
                          <div
                            class="ai_analysis_gr_table_grp3"
                            style="padding-left: 5px; box-sizing: border-box"
                          >
                            <span class="blurred-element"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!isFreemiumUser">
                    <div
                      class="ai_analysis_gr_table_content"
                      *ngFor="let chartData of barchartData; let i = index"
                      (click)="onChartClick(chartData)"
                      [ngClass]="{
                        selected: chartData.selected,
                        blurElement: chartData?.blurElement
                      }"
                    >
                      <div class="ai_analysis_gr_table_grp1">
                        <h1>
                          {{
                            chartData?.value >= 0 ? rename_variables_positive?.[removeCommas(chartData?.name)]?.name ??
                            chartData.name : 
                              renamed_variables?.[removeCommas(chartData?.name)]?.name ??
                            chartData.name
                          }}
                        </h1>
                      </div>
                      <div
                        class="ai_analysis_gr_table_grp2"
                        style="padding-left: 5px; box-sizing: border-box"
                      >
                        <span
                          >{{
                          formatNumberWithCommas(
                            barchartInputData?.variable_labels?.[chartData.name]
                          )
                          }}
                        </span>
                      </div>
                      <div
                        class="ai_analysis_gr_table_grp3"
                        style="padding-left: 5px; box-sizing: border-box"
                      >
                        <div
                          class="percentage"
                          [ngClass]="{
                            positive: chartData?.value > 0,
                            negative: chartData?.value < 0,
                            neutral: chartData?.value == 0
                          }"
                        >
                          {{ formatValue(chartData.value) }}
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div
            class="ai_analysis_gr_main"
            style="display: flex; flex-direction: column"
          >
            <div class="ai_analysis_gr_main-header">
              <div class="ai_analysis_gr_main-header-title">
                <h2>{{ "words.insights" | translate }}</h2>
              </div>
            </div>
            <div class="barchart_with_description-description" style="flex: 1">
              <h3>
                {{
                  selectedFactor?.value >= 0 ?( rename_variables_positive?.[removeCommas(selectedFactor?.name)]?.name ||
                    selectedFactor?.name) : (renamed_variables?.[removeCommas(selectedFactor?.name)]?.name ||
                    selectedFactor?.name)
                }}
              </h3>
              <p>
                {{
                  selectedFactor?.value >= 0 ? (rename_variables_positive?.[removeCommas(selectedFactor?.name)]?.description ||
                    selectedFactor?.description) : (renamed_variables?.[removeCommas(selectedFactor?.name)]?.description ||
                    selectedFactor?.description)
                }}
              </p>

              <table class="analysis-table" style="margin-top: auto">
                <thead>
                  <tr>
                    <th class="table-header">
                      {{ "words.topic" | translate }}
                    </th>
                    <th class="table-header">
                      <!-- {{
                        selectedFactor.name.includes("_sim")
                          ? "Optimal Score"
                          : "Optimal Value"
                      }} -->
                      <div
                        *ngIf="cardName?.includes('Relevance')"
                        matTooltip="{{
                          'phrases.a_measure_of_how_closely_your_content_matches_the_users_search_intent_and_query'
                            | translate
                        }}"
                        matTooltipPosition="above"
                      >
                        {{ "words.relevance_score" }}
                      </div>
                      <div *ngIf="!cardName?.includes('Relevance')">
                        {{ "words.value" | translate }}
                      </div>
                    </th>

                    <th
                      class="table-header"
                      [ngStyle]="{
                        opacity: show_optimal_value ? '1' : '0'
                      }"
                    >
                      {{
                        "words." +
                          (cardName?.includes("Relevance")
                            ? "optimal_score"
                            : "optimal_value") | translate
                      }}
                    </th>
                    <th class="table-header">
                      {{ "words.ranking_impact" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="table-cell">
                      {{
                        isViewAllActiveProject
                          ? ("words.your_sites" | translate)
                          : ("words.your_site" | translate)
                      }}
                    </td>
                    <td class="table-cell">
                      {{ formatValueString(selectProjectInsight?.["value"]) }}
                    </td>
                    <td class="table-cell">
                      {{ selectProjectInsight?.["range"] }}
                    </td>
                    <td class="table-cell">
                      <span
                        *ngIf="selectProjectInsight"
                        class="impact"
                        [ngClass]="{
                          'impact-positive': selectProjectInsight?.['impact'] > 0,
                          'impact-negative': selectProjectInsight?.['impact'] < 0,
                          'impact-neutral': selectProjectInsight?.['impact'] == 0
                        }"
                      >
                        {{ selectProjectInsight?.["impact"]?.toFixed(2) }}
                      </span>
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                    competitorInsight &&
                      !(
                        seoSubscription == 'Premium' &&
                        competitorInsight?.['impact'] == 0
                      )
                      &&
                      seoSubscription == 'Premium'
                    "
                  >
                    <td class="table-cell">
                      {{ domainSelected?.domain || "Competitor" }}
                    </td>
                    <td
                      class="table-cell"
                      [ngStyle]="{
                        filter:
                          seoSubscription == 'Premium'
                            ? 'blur(0px)'
                            : 'blur(4px)'
                      }"
                    >
                      {{ formatValueString(competitorInsight?.["value"]) }}
                    </td>
                    <td
                      class="table-cell"
                      [ngStyle]="{
                        filter:
                          seoSubscription == 'Premium'
                            ? 'blur(0px)'
                            : 'blur(4px)'
                      }"
                    >
                      {{ competitorInsight?.["range"] }}
                    </td>
                    <td
                      class="table-cell"
                      [ngStyle]="{
                        filter:
                          seoSubscription == 'Premium'
                            ? 'blur(0px)'
                            : 'blur(4px)'
                      }"
                    >
                      <span
                        class="impact"
                        [ngClass]="{
                          'impact-positive': competitorInsight?.['impact'] > 0,
                          'impact-negative': competitorInsight?.['impact'] < 0,
                          'impact-neutral': competitorInsight?.['impact'] == 0
                        }"
                      >
                        {{ competitorInsight?.["impact"].toFixed(2) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- <ng-container *ngIf="showMeterChart">
                <app-meter-chart
                  [input_values]="meter_object"
                ></app-meter-chart>
              </ng-container> -->
            </div>
          </div>
        </div>
        <div class="ai_analysis_gr-v2" *ngIf="showV2Design">
          <div class="ai_analysis_gr-v2_table">
            <div class="ai_analysis_gr-v2_table-header">
              <div class="ai_analysis_gr-v2_table-row">
                <div class="ai_analysis_gr-v2_table-row_cell">
                  {{ "words.factor" | translate }}
                </div>
                <div class="ai_analysis_gr-v2_table-row_cell">
                  {{ "words.keywords" | translate }}
                </div>
                <div class="ai_analysis_gr-v2_table-row_cell">
                  {{ "words.ranking_impact" | translate }}
                </div>
                <div class="ai_analysis_gr-v2_table-row_cell">
                  {{ "words.insights" | translate }}
                </div>
              </div>
            </div>
            <div class="ai_analysis_gr-v2_table-body">
              <div
                class="ai_analysis_gr-v2_table-row"
                *ngFor="let item of barchartData"
              >
                <div class="ai_analysis_gr-v2_table-row_cell">
                  {{ renamed_variables?.[removeCommas(item?.name)]?.name ?? item.name }}
                </div>
                <div class="ai_analysis_gr-v2_table-row_cell">
                  {{ formatNumberWithCommas(
                            barchartInputData?.variable_labels?.[item.name]
                          ) }}
                </div>
                <div class="ai_analysis_gr-v2_table-row_cell">
                  {{ formatValue(item.value) }}
                </div>
                <div class="ai_analysis_gr-v2_table-row_cell">
                  {{ renamed_variables?.[removeCommas(item?.name)]?.description || item?.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- comparable chart -->
    <ng-container *ngIf="comparableChart">
      <ng-container *ngIf="!barchartData || barchartData?.length === 0">
        <div class="ai_analysis-custom-barchart_with_description">
          <div
            class="barchart_with_description-factors ai_analysis-custom-barchart-comparable-factors"
          >
            <div
              class="ai_analysis-custom-barchart ai_analysis-custom-barchart-comparable"
              style="justify-content: center"
            >
              <p class="custom-barchart_text_name">
                {{ "phrases.no_data_found" | translate }}
              </p>
            </div>
          </div>
        </div>
      </ng-container>
      <div
        class="ai_analysis-custom-barchart_with_description"
        *ngIf="barchartData && barchartData?.length > 0"
      >
        <div
          class="barchart_with_description-factors ai_analysis-custom-barchart-comparable-factors"
        >
          <div
            class="ai_analysis-custom-barchart ai_analysis-custom-barchart-comparable position-sticky"
          >
            <div
              class="ai_analysis-custom-barchart_bars-container barchart_bars-client-side"
            >
              <p>YOU</p>
            </div>
            <div class="ai_analysis-custom-barchart_values-container">
              <div class="ai_analysis-custom-barchart_values-container_name">
                {{ "words.position" | translate }}
              </div>
              <div class="ai_analysis-custom-barchart_values-container_value">
                <p>{{ clientPosition }}</p>
                <div
                  class="ai_analysis-custom-barchart_values-container_separator"
                ></div>
                <p>{{ competitorPosition }}</p>
              </div>
            </div>
            <div
              class="ai_analysis-custom-barchart_bars-container barchart_bars-competitor-side"
            >
              <ng-container *ngIf="!comparableChart">
                <p>
                  {{ competitorURL }}
                </p>
              </ng-container>

              <ng-container *ngIf="comparableChart">
                <div class="custom_option_picker ai_analysis-custom-barchart">
                  <mat-form-field>
                    <mat-select
                      [(ngModel)]="competitorURL"
                      (selectionChange)="competitorUrlChangedFunc()"
                    >
                      <mat-option
                        *ngFor="let comp of competitors"
                        [value]="comp.url"
                      >
                        {{ comp.rank }}.
                        {{
                          comp?.url
                            ?.replace("https://", "")
                            ?.replace("http://", "")
                            ?.replace("www.", "")
                        }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </ng-container>
            </div>
          </div>
          <div
            class="ai_analysis-custom-barchart ai_analysis-custom-barchart-comparable"
            *ngFor="let chartData of barchartData"
            (click)="onChartClick(chartData)"
            [ngClass]="{ selected: chartData.selected }"
          >
            <div
              class="ai_analysis-custom-barchart_bars-container barchart_bars-client-side"
              [matTooltip]="chartData.clientObject.hoverText"
              matTooltipPosition="above"
            >
              <div
                class="ai_analysis-custom-barchart_bars"
                [ngStyle]="{ width: chartData.clientObject?.percentage + '%' }"
                [ngClass]="{
                  'barchart_bars-red': chartData.clientObject?.corr_sign > 0
                }"
                *ngIf="!overview_filter_active"
              >
                <div
                  class="ai_analysis-custom-barchart_bars-value"
                  [ngClass]="{
                    'barchart_bars-value-outside':
                      chartData?.clientObject?.percentage < 40
                  }"
                >
                  {{
                    chartData?.clientObject?.corr_sign > 0 &&
                    chartData?.clientObject?.value != "0.0"
                      ? "-"
                      : ""
                  }}{{ chartData?.clientObject?.value?.replace("-", "") }}
                </div>
              </div>
              <div
                class="ai_analysis-custom-barchart_bars"
                [ngStyle]="{ width: chartData.clientObject?.percentage + '%' }"
                [ngClass]="{
                  'barchart_bars-red': chartData?.clientObject?.value < 0
                }"
                *ngIf="overview_filter_active"
              >
                <div
                  class="ai_analysis-custom-barchart_bars-value"
                  [ngClass]="{
                    'barchart_bars-value-outside':
                      chartData?.clientObject?.percentage < 40
                  }"
                >
                  {{ chartData?.clientObject?.value }}
                </div>
              </div>
            </div>
            <div class="ai_analysis-custom-barchart_values-container">
              <div
                class="ai_analysis-custom-barchart_values-container_name"
                [ngClass]="{
                  onlyNames:
                    !chartData?.clientObject?.variable_values &&
                    !chartData?.competitorObject?.variable_values
                }"
              >
                {{ chartData.showName ? chartData.showName : chartData.name }}
              </div>
              <div class="ai_analysis-custom-barchart_values-container_value">
                <p>
                  {{ chartData?.clientObject?.variable_values }}
                </p>
                <div
                  class="ai_analysis-custom-barchart_values-container_separator"
                ></div>
                <p>
                  {{ chartData?.competitorObject?.variable_values }}
                </p>
              </div>
            </div>
            <div
              class="ai_analysis-custom-barchart_bars-container barchart_bars-competitor-side"
              [matTooltip]="chartData?.competitorObject?.hoverText"
              matTooltipPosition="above"
            >
              <div
                class="ai_analysis-custom-barchart_bars"
                [ngStyle]="{
                  width: chartData?.competitorObject?.percentage + '%'
                }"
                [ngClass]="{
                  'barchart_bars-red':
                    chartData?.competitorObject?.corr_sign > 0
                }"
                *ngIf="!overview_filter_active"
              >
                <div
                  class="ai_analysis-custom-barchart_bars-value"
                  [ngClass]="{
                    'barchart_bars-value-outside':
                      chartData?.competitorObject?.percentage < 40
                  }"
                >
                  {{
                    chartData?.competitorObject?.corr_sign > 0 &&
                    chartData?.competitorObject?.value != "0.0"
                      ? "-"
                      : ""
                  }}{{ chartData?.competitorObject?.value?.replace("-", "") }}
                </div>
              </div>
              <div
                class="ai_analysis-custom-barchart_bars"
                [ngStyle]="{
                  width: chartData?.competitorObject?.percentage + '%'
                }"
                [ngClass]="{
                  'barchart_bars-red': chartData?.competitorObject?.value < 0
                }"
                *ngIf="overview_filter_active"
              >
                <div
                  class="ai_analysis-custom-barchart_bars-value"
                  [ngClass]="{
                    'barchart_bars-value-outside':
                      chartData?.competitorObject?.percentage < 40
                  }"
                >
                  {{ chartData?.competitorObject?.value }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="barchart_with_description-description">
          <h3>
            {{
              selectedFactor?.showName
                ? selectedFactor?.showName
                : selectedFactor?.name
            }}
          </h3>
          <p>{{ selectedFactor?.description }}</p>

          <ng-container *ngIf="showMeterChart">
            <app-meter-chart [input_values]="meter_object"></app-meter-chart>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <!-- loaders -->
    <ng-container *ngIf="loadingChart">
      <div
        class="ai_analysis-custom-barchart ai_analysis-custom-barchart-skeleton"
        *ngFor="let chartData of [1, 2, 3, 4, 5, 6]"
      >
        <div class="ai_analysis-custom-barchart_text-container">
          <div class="skeleton-box-square" fxLayoutAlign="space-between">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '40px',
                width: '60px',
                outline: 'none',
                'background-color': '#37474f1a',
                'margin-right': '10px'
              }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '40px',
                width: '340px',
                outline: 'none',
                'background-color': '#37474f1a'
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>
        <div class="ai_analysis-custom-barchart_bars-container">
          <div class="skeleton-box-square" style="width: 100%">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '40px',
                outline: 'none',
                'background-color': '#37474f1a'
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
